export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              联系我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              平台收录 & 意见反馈
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              欢迎优质视频平台申请收录，或向我们反馈使用建议
            </p>
          </div>

          <div className="max-w-lg mx-auto">
            <div className="bg-background-100 rounded-2xl p-8 md:p-10 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 text-primary-500 mb-5">
                <i className="ri-mail-send-line text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3 font-heading">
                期待你的声音
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                如果你是视频平台运营者，希望加入69视频的推荐目录；或者作为观众，有任何使用上的建议和反馈，都欢迎通过以下方式与我们取得联系。我们会在收到信息后尽快处理。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="mailto:contact@69video.example.com"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-mail-line"></i>
                  发送邮件
                </a>
                <span className="text-sm text-foreground-400">
                  或通过站内渠道提交反馈表单
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}